import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row justify-center" }
const _hoisted_2 = { class: "col-lg-7 col-md-8 col-sm-10 col-xs-11" }
const _hoisted_3 = { class: "text-h6" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "row justify-center" }
const _hoisted_6 = { class: "col-lg-7 col-md-8 col-sm-10 col-xs-11" }
const _hoisted_7 = { class: "text-h5 q-my-md text-weight-bolder" }
const _hoisted_8 = { class: "text-subtitle1 q-mb-md" }
const _hoisted_9 = { class: "text-body1" }
const _hoisted_10 = { class: "text-body1" }
const _hoisted_11 = { class: "text-body1" }

import { GoogleSpreadsheet } from "google-spreadsheet";
import { ref, onMounted, computed } from "vue";

interface Vacant {
  name: string;
  description: string;
  functions: string[];
  requirements: string[];
  skills: string;
  color: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VacantsView',
  setup(__props) {

const vacantsList = ref<Vacant[]>([]);
const selectedVacant = ref<Vacant>();
const vacantModal = ref(false);

const seeMoreVacant = (vacant: Vacant) => {
  selectedVacant.value = vacant;
  vacantModal.value = true;
};

const vacancyFunctions = computed(() =>
  selectedVacant.value?.functions[0].split("\n")
);

const vacancyRequirements = computed(() =>
  selectedVacant.value?.requirements[0].split("\n")
);

const vacancySkills = computed(() => selectedVacant.value?.skills.split("\n"));

onMounted(async () => {
  const doc = new GoogleSpreadsheet(
    "1nv0WbFZLqSopn_dfprlHkPaHaj523P5-W_QSMzsc24w",
    { apiKey: "AIzaSyB62kWNPR7ApeDQ6heA2n1GIhDeQwDQHZU" }
  );

  await doc.loadInfo();

  const sheet = doc.sheetsByIndex[0];

  let rows = await sheet.getRows();
  let step = 1;
  rows.forEach((row) => {
    if (step > 3) step = 1;
    const vacant: Vacant = {
      name: row.get("nombre"),
      description: row.get("descripcion"),
      functions: row.get("funciones").split(";"),
      requirements: row.get("requisitos").split(";"),
      skills: row.get("competencias"),
      color: step,
    };
    vacantsList.value.push(vacant);
    step++;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_page = _resolveComponent("q-page")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "adicon-font-1" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vacantsList.value, (vacant) => {
            return (_openBlock(), _createBlock(_component_q_card, { class: "q-my-lg card-shadow" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(vacant.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(vacant.description), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      label: "Ver mas",
                      flat: "",
                      color: "deep-orange-7",
                      "no-caps": "",
                      rounded: "",
                      onClick: ($event: any) => (seeMoreVacant(vacant))
                    }, null, 8, ["onClick"]),
                    _createElementVNode("a", {
                      href: `mailto:vacantes@amradvisors.com.pa?subject=${vacant.name}`
                    }, [
                      _createVNode(_component_q_btn, {
                        label: "Aplicar",
                        rounded: "",
                        "no-caps": "",
                        color: "cyan-8",
                        unelevated: "",
                        flat: "",
                        class: "q-ml-md"
                      })
                    ], 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 256))
        ])
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: vacantModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vacantModal).value = $event)),
        maximized: "",
        "transition-show": "slide-up",
        "transition-hide": "slide-down"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "bg-cyan-8 text-white adicon-font-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_bar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_space),
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    dense: "",
                    flat: "",
                    icon: "close"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { class: "bg-white text-cyan-8" }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("Cerrar")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(selectedVacant.value?.name), 1),
                      _createVNode(_component_q_separator, {
                        class: "q-mb-md",
                        color: "white"
                      }),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(selectedVacant.value?.description), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-h6 text-bold" }, [
                        _createElementVNode("u", null, "Funciones")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vacancyFunctions.value, (funct) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(funct), 1))
                      }), 256)),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-h6 text-bold q-mt-md" }, [
                        _createElementVNode("u", null, "Requisitos")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vacancyRequirements.value, (req) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(req), 1))
                      }), 256)),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-h6 text-bold q-mt-md" }, [
                        _createElementVNode("u", null, "Habilidades")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vacancySkills.value, (skill) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(skill), 1))
                      }), 256))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})